var _rect, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 20,
    viewBox: "0 0 64 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_38_603",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 19,
    rx: 9.5,
    fill: "#ED6F8D",
    stroke: "#ED6F8D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_38_603)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 19,
    rx: 9.5,
    fill: "#474B5A",
    stroke: "#474B5A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.9625 6.04459C36.6863 5.76834 36.24 5.76834 35.9638 6.04459L32.5 9.50126L29.0363 6.03751C28.76 5.76126 28.3138 5.76126 28.0375 6.03751C27.7613 6.31376 27.7613 6.76001 28.0375 7.03626L31.5013 10.5L28.0375 13.9638C27.7613 14.24 27.7613 14.6863 28.0375 14.9625C28.3138 15.2388 28.76 15.2388 29.0363 14.9625L32.5 11.4988L35.9638 14.9625C36.24 15.2388 36.6863 15.2388 36.9625 14.9625C37.2388 14.6863 37.2388 14.24 36.9625 13.9638L33.4988 10.5L36.9625 7.03626C37.2317 6.76709 37.2317 6.31376 36.9625 6.04459Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(24 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocked);
export default __webpack_public_path__ + "static/media/blocked.cb6054f9e626a54deb97bd0ee636fa60.svg";
export { ForwardRef as ReactComponent };